/**
 * Based on how many rows is in a page, finds in which page specific row is contained in.
 * Used for Server Side pagination with AG grid
 *
 * @param {number} rowNumber
 * @param {number} rowsPerPage
 * @return {*}  {number}
 */
export const findPageNumber = (
  rowNumber: number,
  rowsPerPage: number
): number => {
  return Math.ceil(rowNumber / rowsPerPage) + 1;
};
